import "core-js/modules/es.array.filter";
import "core-js/modules/es.object.to-string";
import _objectSpread from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapState } from "vuex";
import util from '@/libs/util';
import axios from 'axios';
export default {
  data: function data() {
    return {
      fileList: [],
      fileLoading: false,
      dialogShow: false
    };
  },
  created: function created() {},
  computed: _objectSpread({}, mapState("d2admin", {
    rawData: function rawData(state) {
      return state.serchSelect.rawData;
    }
  })),
  methods: {
    open: function open() {
      this.dialogShow = true;
    },
    closeDialog: function closeDialog() {
      this.dialogShow = false;
    },
    handleExceed: function handleExceed() {
      this.$message.error("\u53EA\u80FD\u4E0A\u4F20\u4E00\u4E2A\u6587\u4EF6!");
    },
    handleChange: function handleChange(file, fileList) {
      this.fileList = fileList;
    },
    handleRemove: function handleRemove(file, fileList) {
      this.fileList = this.fileList.filter(function (item) {
        return item.uid !== file.uid;
      });
    },
    beforeUpload: function beforeUpload(file) {
      var isLt10M = file.size / 1024 / 1024 < 2;

      if (!isLt10M) {
        this.$message.error('上传文件大小不能超过 2MB!');
      }

      return isLt10M;
    },
    submitUpload: function submitUpload() {
      var _this = this;

      var fileList = this.fileList;

      if (fileList.length !== 1) {
        this.$message.warning('请选取文件');
        return;
      }

      this.fileLoading = true;
      var formData = new FormData();
      formData.append("consume_file", fileList[0].raw);
      formData.append("game_id", this.rawData.game_id);
      var reqFn = "/financial/upload_consume_add";
      axios.post(process.env.VUE_APP_API + reqFn, formData, {
        headers: {
          "Content-Type": 'multipart/form-data',
          "Authorization": 'Bearer ' + (util.cookies.get('token') || ''),
          "Request-Url": this.$route.path
        }
      }).then(function (res) {
        if (res.data.status == 200) {
          _this.$emit('change');

          _this.dialogShow = false;
        } else {
          _this.$message.error(res.data.message || res.data.msg);
        }
      }).finally(function () {
        _this.fileLoading = false;
      });
    }
  }
};